export const GA_EVENTS = {
  STORES_LIST: {
    category: 'Stores',
    action: 'List',
  },
  APPOINTMENT: {
    category: 'Appointment',
    action: 'Create',
  },
  CARS_QUOTE: {
    category: 'Quote',
    action: 'Cars',
  },
  JEWELRY_QUOTE: {
    category: 'Quote',
    action: 'Jewelry',
  },
  DIAMONDS_QUOTE: {
    category: 'Quote',
    action: 'Diamonds',
  },
  WATCHES_QUOTE: {
    category: 'Quote',
    action: 'Watches',
  },
  REGISTRATION: {
    category: 'Registration',
    action: '',
    label: '',
  },
  ERROR: {
    category: 'Error',
    action: '',
    label: '',
  },
};

export const GA_REGISTRATION_ACTIONS = {
  START: 'start',
  COMPLETE: 'complete',
  EXIT: 'exit',
  ERROR: 'error',
  EVENT: 'event',
};

export const GA_ERROR_ACTIONS = {
  COLLECTIONS_ERROR: 'collections_error',
};

export const GA_REGISTRATION_LABELS = {
  START_SUBMIT_INE: 'start_submit_ine',
  START_SUBMIT_CLIENT_ID: 'start_submit_client_id',
  BASIC_INFO_SUBMIT: 'basic_info_submit',
  OTP_VALIDATION_SUBMIT: 'otp_validation_submit',
  OTP_VALIDATION_RESEND: 'otp_validation_resend',
  CAPTURE_STARTED: 'capture_started',
  CAPTURE_CANCELLED_INTRO: 'capture_cancelled_intro',
  CAPTURE_CANCELLED_CAPTURE: 'capture_cancelled_capture',
  CAPTURE_COMPLETED: 'capture_completed',
  CAPTURE_SCORE: 'capture_score',
  CAPTURE_AGAIN: 'capture_again',
  CAPTURE_SUCCESS: 'capture_success',
  CAPTURE_FAILED: 'capture_failed',
  ADDRESS_VALID: 'address_valid',
  ADDRESS_INVALID: 'address_invalid',
  SUCCESS_BASIC_EXIT: 'success_basic_exit',
  SUCCESS_BASIC_CONTINUE: 'success_basic_continue',
};
